import { ThemedColor } from './types';

export const SYSTEM_PALETTE_ID = 'system';

// the application's own colors, the same everywhere and not edited
export enum SystemColor {
	Background = 'background',
	BackgroundGray = 'background-gray',
	Text = 'text',
	Heading = 'heading',
	Border = 'border',
	Critical = 'severity-critical',
	Major = 'severity-major',
	Minor = 'severity-minor',
	Ok = 'severity-none',
	Invalid = 'severity-invalid',
}

type SystemColorDefinition = ThemedColor & {
	// the CSS variable it is set as for the stylesheets
	cssVar: string;
	// with lighter and darker variables next to it
	shades?: boolean;
};

export const SYSTEM_COLORS: Record<SystemColor, SystemColorDefinition> = {
	[SystemColor.Background]: { light: '#ffffff', dark: '#1b1e24', cssVar: '--ceeview-background-color' },
	[SystemColor.BackgroundGray]: { light: '#f1f4f9', dark: '#0d0f13', cssVar: '--ceeview-background-gray-color' },
	[SystemColor.Text]: { light: '#555555', dark: '#ffffffd9', cssVar: '--ceeview-text-color' },
	[SystemColor.Heading]: { light: '#3b3e42', dark: '#ffffffe0', cssVar: '--ceeview-heading-color' },
	[SystemColor.Border]: { light: '#d8d8d8', dark: '#424242', cssVar: '--ceeview-border-color' },
	[SystemColor.Critical]: { light: '#da1e28', dark: '#fa4d56', cssVar: '--ceeview-severity-critical', shades: true },
	[SystemColor.Major]: { light: '#ff832b', dark: '#ff832b', cssVar: '--ceeview-severity-major', shades: true },
	[SystemColor.Minor]: { light: '#f1c21b', dark: '#f1c21b', cssVar: '--ceeview-severity-minor', shades: true },
	[SystemColor.Ok]: { light: '#24a148', dark: '#42be65', cssVar: '--ceeview-severity-none', shades: true },
	[SystemColor.Invalid]: { light: '#6f6f6f', dark: '#8d8d8d', cssVar: '--ceeview-severity-invalid', shades: true },
};
